"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getCounterFromLocalStorage = function getCounterFromLocalStorage() {
  var _value$length, _value;

  var value = localStorage.getItem("react-bookmark");
  if (!value) return 0;
  value = JSON.parse(value);
  return (_value$length = (_value = value) === null || _value === void 0 ? void 0 : _value.length) !== null && _value$length !== void 0 ? _value$length : 0;
};

var _default = getCounterFromLocalStorage;
exports.default = _default;